import { render, staticRenderFns } from "./ClaimsRequest.vue?vue&type=template&id=ba1bf886"
import script from "./ClaimsRequest.vue?vue&type=script&lang=js"
export * from "./ClaimsRequest.vue?vue&type=script&lang=js"
import style0 from "./ClaimsRequest.vue?vue&type=style&index=0&id=ba1bf886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports